<template>
  <div class="content" ref="content">
    <div v-if="iscn" class="text text-earth-warn">
      <p>为什么二手拯救世界</p>
      <img class="ask animate__animated" ref="ask" src="../assets/ask.png" alt="">
    </div>
    <div v-if="!iscn" class="text text-en text-earth-warn">
      <p>Why second-hand matters in saving our planet</p>
      <img class="ask animate__animated" ref="ask" src="../assets/ask.png" alt="">
    </div>
    <div class="earth-pic earth-pic-fast" ref="earthPic">
      <div v-if="iscn" class="pic1" ref="pic1"></div>
      <div v-if="iscn" class="pic2" ref="pic2"></div>
      <div v-if="iscn" class="pic3" ref="pic3"></div>
      <div v-if="!iscn" class="pic1 pic1-en" ref="pic1"></div>
      <div v-if="!iscn" class="pic2 pic2-en" ref="pic2"></div>
      <div v-if="!iscn" class="pic3 pic3-en" ref="pic3"></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Rellax from 'rellax'

export default Vue.extend({
  name: 'earth-waring-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
    this.initAnimation()

    new Rellax('.text-earth-warn', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
    new Rellax('.earth-pic', {
      speed: 1,
      center: true,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    })
  },
  methods: {
    initAnimation() {
      // 监听滚动事件，当元素earthPic进入视口时，给元素增加动画类
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // 监听问号出现
            if (entry.target === this.$refs.ask && entry.isIntersecting) {
              if (!this.$refs.ask.classList.contains('animate__slideInUp')) {
                this.$refs.ask.classList.add('animate__slideInUp')
              }
            }
            // 为什么下三张图片的展示
            if (entry.target === this.$refs.earthPic && entry.isIntersecting) {
              setTimeout(() => {
                // pic1-pic4 4个元素，按顺序每隔0.3秒增加zoom-in类
                this.$refs.pic1.classList.add('zoom-in')
                setTimeout(() => {
                  this.$refs.pic2.classList.add('zoom-in')
                  setTimeout(() => {
                    this.$refs.pic3.classList.add('zoom-in')
                  }, 200)
                }, 200)
              }, 70)
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
      )
      observer.observe(this.$refs.earthPic)
      observer.observe(this.$refs.ask)
    }
  }
})
</script>

<style scoped lang="scss">
@keyframes zoomIn {
  from {
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomInPic {
  from {
    transform: scale3d(0.9, 0.9, 0.9);
    opacity: 0;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(200px);
  }

  to {
    transform: translateY(0);
  }
}

.text2-animation {
  animation: fadeIn 1s 0s forwards;
}

.zoom-in {
  animation: zoomIn 1s 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-fast {
  animation: zoomIn 800ms 0s forwards;
  animation-timing-function: linear;
}

.zoom-in-pic {
  animation: zoomInPic 1s 0s forwards;
}

.content {
  position: relative;
  z-index: 3;
  width: 1920px;
  min-width: 1280px;
  max-width: 1920px;
  height: 1221px;
  // height: 2925px;
  margin: 0 auto;
  background: #fff;
}

.text {
  position: absolute;
  top: 250px;
  left: 50%;
  width: 1223px;
  height: 206px;
  margin-left: -616px;
  background: url('../assets/middle-4.png') no-repeat 0 0/ 100% 100%;
  p {
    width: 100%;
    margin-top: 60px;
    color: #111;
    font-size: 80px;
    font-family: alibaba;
    line-height: 80px;
    text-align: center;
  }
  .ask {
    width: 124px;
    height: 151px;
    position: absolute;
    top: 58px;
    left: -65px;
  }
}

.text-en {
  width: 1533px;
  height: 205px;
  margin-left: -767px;
  p {
    width: 100%;
    // margin-top: 66px;
    color: #000;
    font-size: 60px;
    font-family: alibaba;
    line-height: 80px;
    text-align: center;
  }
}

.earth-pic {
  position: absolute;
  top: 556px;
  left: 50%;
  display: flex;
  width: 1540px;
  margin-left: -770px;
  .pic1 {
    width: 500px;
    height: 465px;
    margin: 0 8px;
    background: url('../assets/pic-1.png') no-repeat 0 0/ 100% 100%;
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }
  .pic1-en {
    background-image: url('../assets/melting-glacier.png');
  }
  .pic2 {
    width: 500px;
    height: 465px;
    margin: 0 8px;
    background: url('../assets/pic-2.png') no-repeat 0 0/ 100% 100%;
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }
  .pic2-en {
    background-image: url('../assets/extreme-weathers.png');
  }
  .pic3 {
    width: 500px;
    height: 465px;
    margin: 0 8px;
    background: url('../assets/pic-3.png') no-repeat 0 0/ 100% 100%;
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }
  .pic3-en {
    background-image: url('../assets/global-warming.png');
  }
  .pic4 {
    width: 390px;
    height: 480px;
    background: url('../assets/pic-4.png?v=1') no-repeat 0 0/ 100% 100%;
    transform: scale3d(0.7, 0.7, 0.7);
    opacity: 0;
  }
  .pic4-en {
    background-image: url('../assets/pic-4-en.png');
  }
  .text-t {
    margin-top: 230px;
    margin-left: 37px;
    color: #fff;
    font-size: 36px;
    line-height: 36px;
  }
  .text-d {
    margin-top: 10px;
    margin-left: 37px;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
